import {
  AssignChangeAddressVDriveDriverRequestData,
  AssignVDriveDriverRequestData,
  CreateManualOrderRequestData,
  GetAllOrdersCountAndSales,
  GetAllOrdersParams,
  MarkAsRecoveredRequestData,
  OrderAndSalesCountResponse,
} from '../types/api/order.types';
import {
  VDriveGetQuoteHistoryResponse,
  VDriveGetRecordingResponse,
} from '../types/deliveries.types';
import {
  Order,
  OrderAuditLogEntity,
  SimpleOrderEntity,
  VDriveOfferEntity,
} from '../types/order.types';
import {
  DateRangeParams,
  LocationStatus,
  OrderVDriveCancellationFeeResponse,
  ReportExportResponse,
  ResponseType,
} from '../types/shared.types';
import { api } from './api';

export type CreateOrdersReportExportBody = Partial<
  DateRangeParams<{
    locationIds?: Array<number>;
    locationId?: number;
    brandIds?: Array<number>;
    ordersFind?: LocationStatus;
    query?: string;
    includePhysicalLocationsOnly?: boolean;
    sortByDate?: 'asc' | 'desc';
  }>
>;

export const createOrdersReportExport = (
  params: CreateOrdersReportExportBody
) =>
  api.post<ResponseType<ReportExportResponse>>(
    `/v1/orders/report/export`,
    undefined,
    { params }
  );

export const getOrdersReportExport = (id: number | string) =>
  api.get<ResponseType<ReportExportResponse>>(`/v1/orders/report/export/${id}`);

export const getAllOrders = (params: GetAllOrdersParams) =>
  api.get<ResponseType<SimpleOrderEntity[]>>(`/v1/orders`, {
    params,
  });

export const getAllOrderCountAndSales = (params: GetAllOrdersCountAndSales) =>
  api.get<ResponseType<Array<OrderAndSalesCountResponse>>>(
    // isAdmin ? `/v1/orders/sales-per-day` :
    `/v1/orders/sales-per-day-subtotal`,
    { params }
  );

export const getOrderById = (id: string | number) =>
  api.get<ResponseType<Order>>(`/v1/orders/${id}`);

export const getOrdersInterceptorCall = (id: string | number) =>
  api.get<ResponseType<VDriveGetRecordingResponse>>(
    `/v1/orders/${id}/vdrive/call-recording`
  );

export const getOrderAuditLogs = (id: string | number) =>
  api.get<ResponseType<Array<OrderAuditLogEntity>>>(
    `/v1/orders/${id}/audit-logs`
  );

export const getVDriveOffers = (id: string | number) =>
  api.get<ResponseType<Array<VDriveOfferEntity>>>(`/v1/orders/${id}/vdrive`);

export const assignVDriveDriver = (
  id: string | number,
  data: AssignVDriveDriverRequestData
) => api.post<ResponseType<Order>>(`/v1/orders/${id}/vdrive`, data);

export const assignChangeAddressVDriveDriver = (
  id: string | number,
  data: AssignChangeAddressVDriveDriverRequestData
) =>
  api.post<ResponseType<Order>>(`/v1/orders/${id}/vdrive/change-address`, data);

export const cancelOrderVDrive = (id: string | number, reason: string) =>
  api.post<ResponseType<Order>>(`/v1/orders/${id}/cancel-vdrive`, {
    reason,
  });

export const createManualOrder = (data: CreateManualOrderRequestData) =>
  api.post<ResponseType<Order>>('/v1/orders/manual', data);

export const updateManualOrder = (
  id: string | number,
  data: Partial<CreateManualOrderRequestData>
) => api.put<ResponseType<Order>>(`/v1/orders/${id}/manual`, data);

export const deleteManualOrder = (id: string | number) =>
  api.delete<ResponseType<null>>(`/v1/orders/${id}/manual`);

export const recoverOrder = (id: string | number, recovered: number) =>
  api.post<ResponseType<null>>(`/v1/orders/${id}/recover`, { recovered });

export const orderRecovery = (
  id: string | number,
  data: MarkAsRecoveredRequestData
) => api.post<ResponseType<Order>>(`/v1/orders/${id}/recovery`, data);

export const deleteOrderRecovery = (id: string | number) =>
  api.delete<ResponseType<Order>>(`/v1/orders/${id}/recovery`);

export const orderManualPrint = (id: string | number, isFront: boolean) =>
  api.post<ResponseType<null>>(`/v1/orders/${id}/manual-print`, {
    isFront,
  });

export const getCancelVDriveOrderFee = (id: string | number) =>
  api.post<ResponseType<OrderVDriveCancellationFeeResponse>>(
    `/v1/orders/${id}/cancellation-fee`
  );

export const markOrderAsCompleted = (id: string | number) =>
  api.post<ResponseType<Order>>(`/v1/orders/${id}/complete`);

export const getOrdersAssignHistory = (id: string | number) =>
  api.get<ResponseType<VDriveGetQuoteHistoryResponse[]>>(
    `/v1/orders/${id}/vdrive/quotes-history`
  );
